import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { useSearchParams } from "react-router-dom";
import plus from "../../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import top from "../../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faRotate, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";
// import AddOffCanvance from "./Add";
// import EditOffCanvance from "./Edit";
// import ModalDelete from "../../../common/ModalDelete";
import { AddButton, EditButton, DeletButton } from "../../../common/Button";
import ViewOffCanvance from "./ViewOffCanvance";
import Pagination_Holder from "../../../Common _Components/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { AllBookingStatus } from "../../../../utils/apis/masters/masters";
import Select from "react-select";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  // window.location.reload();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
  } = useContext(Context);

  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("c_id");

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const [totalPages, settotalPages] = useState();

  const [onPageChange, setonPageChange] = useState(1);

  const [status, setStatus] = useState([]);
  const [selectStatus, setselectStatus] = useState("");

  const handlePageChange = (pageNumber) => {
    console.log(pageNumber, "pageNumber");

    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const getDataAll = async () => {
    const buildUrl = () => {
      let url = `/customers/rides`;
      const params = new URLSearchParams();

      if (customerId) {
        params.append("c_id", customerId);
      }
      if (onPageChange) {
        params.append("page", onPageChange);
      }
      if (perPage) {
        params.append("per_page", perPage);
      }
      if (search) {
        params.append("term", search);
      }
      if (contact_no) {
        params.append("contact_no", contact_no);
      }
      if (email) {
        params.append("email", email);
      }

      // Ensure `searchParams` is defined before using it
      const status = searchParams?.get("status");
      if (status === "5") {
        params.append("booking_status_id", "5");
      } else if (selectStatus?.value) {
        params.append("booking_status_id", selectStatus.value);
      }

      const finalUrl = `${url}?${params.toString()}`;
      console.log("Final URL:", finalUrl); // Debugging
      return finalUrl;
    };

    try {
      const response = await getData(buildUrl());
      if (response) {
        setData(response);
        setCurrentPage(response?.data?.currentPage || 1);
        setperPage(response?.data?.per_page || 10);
        setSearch(response?.data?.search_name || "");
        setEmail(response?.data?.email || "");
        setContact_no(response?.data?.contact_no || "");
        settotalPages(response?.data?.totalPages || 1);

        // Handle Per_Page_Dropdown safely
        const options = await Per_Page_Dropdown(response?.data?.totalEntries);
        setOption(options || []);

        // Update allChecked if data exists
        const newData = response?.data?.data || [];
        setAllChecked(newData.map((d) => d?.id));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, searchParams, onPageChange]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/customers/rides/${id}`);
    setChangeStatus(response);
  };

  const ChangeVirefiedStatus = async (id) => {
    const response = await editStatusData(`/customers/rides/verified/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/customers/rides/${recordToDeleteId}`);

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);
  const handleViewshow = async (id) => {
    await setview(id);
  };

  const GetAllBookingStatus = async () => {
    const response = await AllBookingStatus();

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "booking_status_id",
          label: data.name,
        });
      });
    }
    setStatus(option);
  };

  useEffect(() => {
    GetAllBookingStatus();
  }, []);

  const handleReset = () => {
    setSearch("");
    setContact_no("");
    setEmail("");
    setselectStatus("");
    setReset(!reset);

    // Update URL without query parameters
    window.history.pushState({}, "", "/customers/rides");

    // Reload the page
    window.location.reload();
  };

  return (
    <>
      <div className="Dashboard">
        <Header title={"Bookings"} link={"/counstomers/rides"} />
        <section className="Advancemain-advancedashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <section className="Tabels tab-radio tab-radio mt-5">
              <div className="">
                <div className="row">
                  <div className="d-flex">
                    <div className="add me-3"></div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className=" col-xxl-3 col-xl-12 col-lg-12 col-md-12 col-12"></div>
                    <div className="col-xxl-9   col-xl-12 col-lg-12  col-md-12 col-12">
                      <div className="d-flex justify-content-end">
                        <div className="sowing me-2">
                          <p className="show mt-2">{`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.totalEntries
                          )} of ${data?.data?.totalEntries} entries`}</p>
                        </div>
                        <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder="Search by Name"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                        {/* <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder="Search by Email"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                          />
                        </div> */}
                        <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder="Search by Contact No"
                            value={contact_no}
                            onChange={(e) => {
                              setContact_no(e.target.value);
                            }}
                          />
                        </div>

                        <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder="Search by Email"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                          />
                        </div>

                        <div className="Search me-2">
                          <button
                            type="button"
                            onClick={() => {
                              getDataAll();
                              setonPageChange(1);
                            }}
                            className="btn btn-search"
                          >
                            <img src={search1} className="search" alt="" />
                          </button>
                        </div>

                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={handleReset}
                            className="btn btn-reset"
                          >
                            <FontAwesomeIcon icon={faRotate} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {visible.col1 && (
                            <th className="tax-name">Sr. No.</th>
                          )}
                          {visible.col2 && (
                            <th className="tax-name">Customer Name </th>
                          )}
                          {visible.col6 && (
                            <th className="tax-name">Contact </th>
                          )}{" "}
                          {visible.col7 && <th className="tax-name">email </th>}
                          {visible.col3 && (
                            <th className="tax-name">Booking Status</th>
                          )}
                          {visible.col4 && <th className="active">Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.data?.length > 0 ? (
                          data?.data?.data?.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                {visible.col2 && <td>{d?.user?.f_name}</td>}
                                {/* {visible.col5 && <td>{d?.email}</td>} */}
                                {visible.col6 && <td>{d?.user?.contact_no}</td>}
                                {visible.col7 && <td>{d?.user?.email}</td>}
                                {visible.col3 && (
                                  <td>
                                    <div className="form-check form-switch success-text">
                                      <label
                                        className="form-check-label"
                                        htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                        style={{
                                          color:
                                            d.booking_status_id === 5
                                              ? "green"
                                              : d.booking_status_id === 1
                                              ? "blue"
                                              : d.booking_status_id === 6
                                              ? "pink"
                                              : "black",
                                        }}
                                      >
                                        {/* {d.rider_status_id === 1 ? "Completed" : d.rider_status_id === 2 ? "Canceled" : "Unknown Status"} */}
                                        {d.booking_status?.name}
                                      </label>
                                    </div>
                                  </td>
                                )}
                                {visible.col4 && (
                                  <td>
                                    <div
                                      className="add me-3"
                                      onClick={() => {
                                        handleViewshow(d?.id);
                                      }}
                                    >
                                      {" "}
                                      <Link
                                        type="button"
                                        className="btn btn-add pe-3"
                                      >
                                        <div>view</div>
                                      </Link>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={6}
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "20px",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>{" "}
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          data={view}
        />
      ) : (
        ""
      )}

      {/* {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      /> */}
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
